"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Http = _interopRequireDefault(require("../network/Http"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayerTimes =
/** @class */
function () {
  function LayerTimes(account) {
    this.account = account;
  }

  LayerTimes.prototype.times = function (layer, limit) {
    var _this = this;

    if (limit === void 0) {
      limit = 20;
    }

    return new Promise(function (resolve, reject) {
      var url = "https://maps.aerisapi.com/" + _this.account.id + "_" + _this.account.secret + "/" + layer + ".json?limit=" + limit;

      _Http.default.request(url).then(function (res) {
        var result = [];

        if (res.data) {
          var data = res.data;

          if ((0, _utils.isset)(data.files)) {
            result = data.files.map(function (time) {
              return {
                time: new Date(time.timestamp * 1000),
                min: new Date(time.minTimestamp * 1000),
                max: new Date(time.maxTimestamp * 1000),
                run: new Date(time.runTime * 1000)
              };
            });
          }
        }

        resolve(result);
      }).catch(function (error) {
        reject(error);
      });
    });
  };

  LayerTimes.prototype.timesInRange = function (layer, from, to, limit) {
    if (limit === void 0) {
      limit = 20;
    }

    return this.times(layer, limit).then(function (times) {
      return times.filter(function (valid) {
        return valid.time.getTime() >= from.getTime() && valid.time.getTime() <= to.getTime();
      });
    });
  };

  return LayerTimes;
}();

var _default = LayerTimes;
exports.default = _default;
module.exports = exports.default;